import { Component, Input } from '@angular/core'
import { BaseChartDirective, provideCharts } from 'ng2-charts'

import { ResponsiveComponent } from '@nx-superprep/shared'
import { BarController, BarElement, CategoryScale, Colors, Legend, LinearScale, Tooltip } from 'chart.js'
import { PerformanceCharts } from '@nx-superprep/backend/firebase'
import { isEqual } from 'lodash-es'

@Component({
  selector: 'pop-ui-performance-charts',
  standalone: true,
  imports: [BaseChartDirective],
  providers: [provideCharts({ registerables: [BarController, BarElement, LinearScale, CategoryScale, Tooltip, Legend, Colors] })],
  templateUrl: './performance-charts.component.html',
  styleUrls: ['./performance-charts.component.scss'],
})
export class PerformanceChartsComponent extends ResponsiveComponent {

  private _charts: PerformanceCharts[] = []
  @Input()
  public get charts(): PerformanceCharts[] {
    return this._charts
  }
  public set charts(value: PerformanceCharts[]) {
    if (isEqual(this._charts, value)) { return }
    this._charts = value
  }
}
